import { Component, OnInit, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Provider } from "app/core/models/provider.model";
import { ProviderService } from 'app/core/services/provider.service';

import { ProviderHeaderComponent } from '../../components/provider-header/provider-header.component';
import { ProviderCommunicationsComponent } from '../../components/provider-communications/provider-communications.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-capture-admin-provider-communications',
    templateUrl: './capture-admin-provider-communications.component.html',
    styleUrls: ['./capture-admin-provider-communications.component.scss'],
    imports: [ProviderHeaderComponent, ProviderCommunicationsComponent, MatProgressSpinner]
})
export class CaptureAdminProviderCommunicationsComponent implements OnInit {
  private providerService = inject(ProviderService);
  private route = inject(ActivatedRoute);


  provider: Provider;
  loading: boolean;

  ngOnInit() {
    this.init();
  }

  private init() {
    const npi = this.route.snapshot.paramMap.get('npi');
    this.loading = true;

    this.providerService.getByNpi(npi).subscribe(provider => {
      this.provider = provider;
      this.loading = false;
    });
  }
}
